import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Moment } from 'moment'
import { Item } from '@/components/weekly-schedule/utils'
import { useStore } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventCellJobDetails',
  props: {
    job: null,
    weekStart: null,
    description: null
  },
  setup(__props: any) {

const props = __props as {
  job: Item
  weekStart: Moment
  description?: string
}


const store = useStore()
const weekViewDoubleHeightJobCard = computed<boolean>(
  () => store.getters['featureFlags/weekViewDoubleHeightJobCard']
)
const formattedStartTime = computed(() => {
  const time = props.job.displayedStartTime.isBefore(props.weekStart)
    ? props.weekStart
    : props.job.displayedStartTime
  return time.toDate().toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hourCycle: 'h23',
  })
})

const cardDescription = computed(() => {
  return props.description ?? props.job.activity?.taskName
})

const formattedPickupLocation = computed(() => {
  if (
    props.job.inventory.length > 0 &&
    !props.job.inventory[0].pickupLocationId
  ) {
    return 'TBD'
  } else if (
    props.job.inventory.length > 0 &&
    props.job.inventory[0].pickupLocationId
  ) {
    return props.job.inventory[0].pickupLocationName ?? ''
  }
  return ''
})
const showArrow = computed(
  () => (formattedPickupLocation.value?.length ?? 0) > 0
)

return { __sfc: true,props, store, weekViewDoubleHeightJobCard, formattedStartTime, cardDescription, formattedPickupLocation, showArrow }
}

})